import React from 'react';
import styles from './needle.module.css';

const Needle = (props) => {
  return (
    <div className={styles.needleContainer} style={props.needleStyle}>
      <div className={styles.triangle}></div>
      <div className={styles.line}></div>
    </div>
  );
};

export default Needle;
